import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

export function initSplide() {
    // 1. find all elements
    let splides = document.querySelectorAll('[data-product-splide]');
    if (!splides.length) return;
    // 2. process all instances
    for (let i = 0; i < splides.length; i++) {
        let splideElement = splides[i];
        let splide = new Splide(splideElement, {
            focus: 'center',
            autoWidth: true,
            pagination: false,
            mediaQuery: 'min',
            perMove: 6,
            preloadPages: 4,
            lazyLoad: 'nearby',
            arrows: true,
        });
        progressBar(splide, $(splideElement).find('.splide-progress-bar'));
        splide.mount();
    }
}

function progressBar(splide, bar) {
    splide.on('mounted move', function () {
        let end = splide.Components.Controller.getEnd() + 1;
        let rate = Math.min((splide.index + 1) / end, 1);
        bar.css('width', String(100 * rate) + '%');
    });
}

export function initAutoScroll() {
    let splides = document.querySelectorAll('.splide[data-splide-autoscroll]');
    if (!splides.length) return;
    for (let i = 0; i < splides.length; i++) {
        let splideElement = splides[i];
        let splide = new Splide(splideElement, {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            mediaQuery: 'min',
            arrows: false,
            lazyLoad: 'nearby',
            preloadPages: 4,
            pagination: false,
            autoWidth: true,
            autoScroll: {
                speed: -0.5,
            }
        });

        splide.mount({AutoScroll});
    }
}